/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCreateCheckoutSessionRequest } from '../models/TCreateCheckoutSessionRequest';
import type { TCreateCheckoutSessionResponse } from '../models/TCreateCheckoutSessionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StripeService {
    /**
     * Create a Stripe Checkout Session for the current user's active group.
     * Returns the hosted Checkout URL to redirect the user to.
     * @param requestBody
     * @returns TCreateCheckoutSessionResponse Ok
     * @throws ApiError
     */
    public static createCheckoutSession(
        requestBody: TCreateCheckoutSessionRequest,
    ): CancelablePromise<TCreateCheckoutSessionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/checkout-session',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
